import React, { useState, useEffect } from 'react';

const IconFromSvg = ({
  path,
  alt,
  width,
  height,
  className,
  alternatePath
}: {
  path: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  alternatePath?: string;
}) => {
  const [imageSrc, setImageSrc] = useState(path);

  useEffect(() => {
    setImageSrc(path);
  }, [path]);

  const handleError = () => {
    if (alternatePath && imageSrc !== alternatePath) {
      setImageSrc(alternatePath);
    }
  };

  return (
    <img
      src={imageSrc}
      alt={alt}
      width={width ? width : 'inherit'}
      height={height ? height : 'inherit'}
      className={className || ''}
      title={alt}
      onError={handleError}
    />
  );
};

export default IconFromSvg;
